
import styled from "styled-components";
import { theme } from "../theme";

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    padding: 0 7% 60px;
    color: ${theme.colors.text};
    margin-bottom: 50px;

    @media (max-width: ${theme.breakpoints.tablet}) {
        padding: 0 5% 40px;
        margin-bottom: 30px;
    }

    @media (max-width: ${theme.breakpoints.mobile}) {
        padding: 0 20px 20px;
        margin-bottom: 10px;
    }
`;

export const Title = styled.h2`
    color: ${theme.colors.colorfulBackground};
    font-size: 40px;
    margin: 20px 0 10px;

    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 32px;
    }

    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 25px;
    }
`;

export const Button = styled.button`
    cursor: pointer;    
    padding: 12px 25px;
    border-radius: 4px;
    background-color: ${theme.colors.colorfulBackground};
    border: 1px solid ${theme.colors.colorfulBackground};
    color: ${theme.colors.white};
    font-weight: ${theme.fonts.weights.superBold} ;
    font-size: 24px;
    transition: 300ms;

    &&:hover{
        background: none;
        transform: translateY(-5px)
    }

    &&:active{
        transform: translateY(0);
        transition: 0ms;
        background-color: ${theme.colors.text};
    }

    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 18px;
        padding: 10px 20px;
    }

    @media (max-width: ${theme.breakpoints.mobile}) {
        padding: 10px 15px;
        font-size: 13px;
    }
`;